import React, { useEffect, useState, useMemo } from 'react'
import Select from "react-select";

import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import ErrorAlert from '../../Alerts/ErrorAlert';
import LoadingAlert from '../../Alerts/LoadingAlert';
import { Badge } from 'react-bootstrap';
import ConfirmationAlert from '../../Alerts/ConfirmationAlert';
import printOrderData from '../../PaymentPost/PrintOrderData';
import AlertSmall from '../../Alerts/AlertSmall';
import Modalclient from '../../PaymentPost/ModalClients';
import ClientPillCard from '../../ClientPillCard/ClientPillCard';
import PhoneInput from 'react-phone-input-2';
import ModalQuoteDetails from '../../PaymentPost/ModalQuoteDetails';
import Swal from "sweetalert2";

//API 
import { BranchOfficeFetchAPI } from '../../../api/BranchOffices';
import { TablesFetchAPI } from '../../../api/Tables';
import { BranchOfficeEnvironmentsFetchAPI } from '../../../api/BranchOfficeEnvironments';
import { PrinterFetchAPI } from '../../../api/Printer';
import { MachinesFetchAPI } from '../../../api/Machines';
import { AuthDgiFetchAPI } from '../../../api/Paymentpost/AuthDgi';
import { PreOrderFetchAPI } from '../../../api/Paymentpost/PreOrder';
import { CategriesPosFetchAPI } from '../../../api/Paymentpost/CategoriesPos';
import { RequestLocalFetchAPI } from '../../../api/Paymentpost/RequestLocal';
import { ClientsFetchAPI } from '../../../api/Clients';
import { MailFetchAPI } from '../../../api/Mail';
import { OrdersFetchAPI } from '../../../api/Orders';
//Utils
import { buildCloudinaryImageUrl } from '../../../utils/CloudinaryImageUrl';
import { showApiError } from '../../../utils/ApiError';
import { hasPreOrderKitchenItemsToPrint } from '../../../utils/PreOrderPaymentPrint';
//IMG
import defaultImage from "../../../assets/img/default.png";

import './ModalCreatePreorder.css'

function ModalCreatePreOrder({ checkDeliveryOrder,
   branchoffice, token,
   removedPreOrderShoppingCartProducts,
   dv, name, ruc, setDv, setName,
   setRuc, dataResponse, optionalData,
   setDataResponse, setOptionalData,
   shoppingCart, shoppingCartCombos,
   total, subtotal, tax, discount,
   setPageLoader, dataPreOrder, taxesArrayAll,
   cardGroup, dataDicountApply, paramsMicros,
   parthner_order, parthners, setdataClientSelected, dataClientSelected,
   addressNowLocation, setAddressNowLocation, setShoppingCart,
   calculateInvoiceTotals, enabledOnlineOrder, selectRestaurant,
   setResetData, setShoppingCartCombos, selectPreOrder, dataStyleBusiness,
   domain, setSelectPreOrder, aditional_data, setAditional_data,
   addresDescriptionClientFiscal, setAddresDescriptionClientFiscal, eventDataState, events }) {


   const [domainBusiness, setDomainBusiness] = useState(() => {
      const storedDomain = localStorage.getItem('business');
      return storedDomain ? JSON.parse(storedDomain).domain : '';
   });
   const [eventDates, setEventDates] = React.useState([]);
   const [selectedEvent, setSelectedEvent] = React.useState(null);
   // Estado para modal de detalles de cotización
   const [showQuoteDetails, setShowQuoteDetails] = useState(false);
   const [selectedQuote, setSelectedQuote] = useState(null);
   let logo = localStorage.getItem('businessLogo');
   const eventsAndDates = () => {
      return (<>
         {events.length > 0 &&
            <Form.Group className="mb-3">
               <Form.Label>Evento</Form.Label>
               <Form.Select
                  value={selectedEvent ? selectedEvent.id : ''}
                  onChange={e => {
                     const eventObj = events.find(ev => String(ev.id) === String(e.target.value));
                     setSelectedEvent(eventObj);
                  }}
               >
                  <option value={null}>Selecciona un evento</option>
                  {(events || [])
                     .map(ev => (
                        <option key={ev.id} value={ev.id}>
                           {ev.name}
                        </option>
                     ))}
               </Form.Select>
            </Form.Group>
         }
      </>)
   }



   const [email, setEmail] = useState("");
   const [email_cc, setEmail_cc] = useState("");
   const [phone, setPhone] = useState("");
   const [formType, setFormType] = useState("preOrder");
   const [show, setShow] = useState(false);
   const [note, setNote] = useState(() => { if (selectPreOrder?.note) { return selectPreOrder.note } else { return "" } });
   const [infoPrinter, setInfoPrinter] = useState({ printer_comanda: "", printer_ticket: "", printer_ip: "" })
   const [printers, setPrinters] = useState([]);
   const [dataOrder, setDataOrder] = useState({});
   const [tableNumber, setTableNumber] = useState(0);
   const [stateRequest, setStateRequest] = useState(false)
   const [preOrderGroups, setPreOrderGroups] = useState([]);
   const [preOrderCombos, setPreOrderCombos] = useState([]);
   const [attachedFiles, setAttachedFiles] = useState([]);
   const [tables, setTables] = useState([]);
   const [zones, setZones] = useState([]);
   const [selectedTable, setSelectedTable] = useState(null);
   const [uploading, setUploading] = useState(false);
   const [showSimplePrintModal, setShowSimplePrintModal] = useState(false);
   const [datacreatePreOrder, setDataCreatePreOrder] = useState({});
   let title_modal = "Crear precuenta"
   let machine = JSON.parse(localStorage.getItem('machine'));
   let user = JSON.parse(localStorage.getItem('user'));
   let date = new Date().toJSON().slice(0, 10)

   const [branchOfficeData, setBranchofficeData] = useState({
      "ruc": "",
      "dv": "",
      "name": "",
      "ruc_type": "",
      "direction": "",
      "dgi_name": "",
   });

   const getPreOrderByid = async () => {
      let machine_token = localStorage.getItem('x-access-machine-token');
      if (dataPreOrder.pre_Order == true) {
         try {
            const response = await PreOrderFetchAPI.getPreOrderById(dataPreOrder._id, machine_token);
            setDataOrder(response.data.pre_order)
            if (response.data.pre_order.is_quote_order == true) {
               setFormType("quote")
            }
            setTableNumber(response.data.pre_order.table_name);
         } catch (err) {

         }
      }
   }

   // Función para manejar el cambio de archivos (máx 10 archivos, cada uno máx 5MB)
   const handleFileChange = (e) => {
      const MAX_FILES = 10;
      const MAX_SIZE_MB = 50;
      const MAX_SIZE_BYTES = MAX_SIZE_MB * 1024 * 1024;
      if (e.target.files && e.target.files.length > 0) {
         let files = Array.from(e.target.files);
         if (files.length > MAX_FILES) {
            AlertSmall(`Solo puedes adjuntar hasta ${MAX_FILES} archivos.`, 'warning');
            e.target.value = '';
            setAttachedFiles([]);
            return;
         }
         const oversized = files.find(file => file.size > MAX_SIZE_BYTES);
         if (oversized) {
            AlertSmall(`El archivo "${oversized.name}" excede el tamaño máximo de ${MAX_SIZE_MB}MB.`, 'warning');
            e.target.value = '';
            setAttachedFiles([]);
            return;
         }
         setAttachedFiles(files);
      }
   };

   // Función para guardar los archivos adjuntos
   const handleSaveFiles = async (order) => {
      if (!attachedFiles.length) return;
      setUploading(true);
      try {
         // State for client name, loaded from localStorage if available
         const formData = new FormData();
         attachedFiles.forEach((file, idx) => {
            formData.append('files', file);
         });
         formData.append('_id', order._id);
         // Aquí deberías llamar a tu API para subir los archivos
         let token = localStorage.getItem('x-access-machine-token');
         const response = await PreOrderFetchAPI.updateOrderTempPreOrderFile(formData, token);

         // await SomeAPI.uploadOrderAttachment(formData);
         AlertSmall('Archivos adjuntados correctamente', 'success');
         // State for client RUC (tax ID), loaded from localStorage if available
         setAttachedFiles([]);
      } catch (err) {
         showApiError(err, {
            title: "No se pudieron adjuntar los archivos",
            message: "Error al adjuntar archivos",
            context: `pre_order_id=${order?._id || ""}`,
         }, ErrorAlert);
      } finally {
         setUploading(false);
      }
   };

   const sendMail = (EmailData) => {
      // Gets a temporary order by code from the API
      let token = localStorage.getItem('x-access-machine-token')
      let data = EmailData


      try {
         const response = MailFetchAPI.sendMail(data, token)
         AlertSmall('Correo enviado con exito', 'success')

      } catch (err) {
         // Gets a temporary order by ID and navigates to the cart/order page
         showApiError(err, {
            title: "Error al enviar correo",
            message: "No se pudo enviar el correo",
         }, ErrorAlert);

      }
   }

   //Function to get a temporal order data by code
   const getTemporalOrderByCode = async (code) => {
      try {
         let token = localStorage.getItem('x-access-machine-token');
         let business = JSON.parse(localStorage.getItem('business'))
         let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
         const response = await OrdersFetchAPI.getTempOrderByCode(code, business.code, branchoffice.code, token);
         // Updates the pre-order with client data and note, sends email, and refreshes order data

         return response;
      } catch (err) {
         showApiError(err, {
            title: "No se pudo consultar la orden",
            message: "Error al consultar la orden temporal",
            context: `code=${code || ""}`,
         }, ErrorAlert);
      }
   }

   //get client by business 
   const getClientsByBusiness = async () => {
      let token = localStorage.getItem('x-access-machine-token');
      let business = JSON.parse(localStorage.getItem('business'))
      return new Promise(async (resolve, reject) => {
         try {

            let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
            let business_id = business.id
            if (parthner_order == true) {
               business_id = branchoffice.parthner_business
            }
            const response = await ClientsFetchAPI.getClientsByBusiness(business_id, token);
            resolve(response.data.data);
         } catch (err) {

            reject(err);
         }
      });
   }


   //function to authentication of ruc
   const authenticationDgi = async () => {
      let message = ""
      let title = ""
      let icon = ""
      if (ruc == "") {
         message = "No se ha ingresado ningun ruc."
         title = "Debes ingresar un ruc."
         icon = "warning"
         ErrorAlert(message, title, icon)
      } else {
         LoadingAlert()
         let token = localStorage.getItem('x-access-machine-token');
         let data = { ruc: ruc }
         try {
            const response = await AuthDgiFetchAPI.authenticationRuc(token, data)
            let dataDgi = response.data
            if (dataDgi.dgi_response.gResProc) {
               if (dataDgi.dgi_response.gResProc.dCodRes == "0680") {
                  let dvDgi = dataDgi.dgi_response.dDV
                  if (dvDgi.length < 2) { dvDgi = "0" + dvDgi }
                  setName(dataDgi.dgi_response.dNomb)
                  setDv(dvDgi)
                  message = "Datos del clientes obtenidos por la DGI"
                  title = "Datos obtenido correctamente"
                  icon = "success"
                  ErrorAlert(message, title, icon)
                  setDataResponse(true)
               } else {
                  setOptionalData(true)
                  message = "Ingrese los datos manualmente."
                  title = "Datos no encontrados"
                  icon = "warning"
                  ErrorAlert(message, title, icon)
               }
            }
         } catch (err) {

            setOptionalData(true)
            message = "Ingrese los datos manualmente."
            title = "Datos no encontrados"
            icon = "warning"
            ErrorAlert(message, title, icon)
         }
      }
   }

   const handlercreateValidation = () => {

      if (paramsMicros != 0) {
         if (paramsMicros.pos_integration_id == 2) {
            formatDataMicrosCheck(shoppingCart, shoppingCartCombos, "create")
         } else {
            createPreOrder()
         }
      } else {
         createPreOrder()
      }
   }


   const handlerUpdateValidation = () => {
      if (paramsMicros != 0) {
         if (paramsMicros.pos_integration_id == 2) {
            handlerComparativeNewData()
         } else {
            updatePreOrder()
         }
      } else {
         updatePreOrder()
      }
   }

   //create preOrder
   const createPreOrder = async (micros) => {
      if (stateRequest == false) {
         if (formType === "quote" && (!email || !phone)) {
            AlertSmall("Para cotización, nombre, correo y teléfono son obligatorios.", "warning")
         } else {
            setStateRequest(true)
            if ((shoppingCart.length + shoppingCartCombos.length) > 0) {
               LoadingAlert()
               let token = localStorage.getItem('x-access-machine-token');
               let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
               let machine = JSON.parse(localStorage.getItem('machine'))


               let json = {
                  "client_name": name,
                  "table_name": tableNumber,
                  "client_phone": dataClientSelected != null ? dataClientSelected.phone : "",
                  "ruc": ruc,
                  "dv": dv,
                  "id_Client": dataClientSelected != null ? dataClientSelected.id : 0,
                  "client_id": dataClientSelected != null ? dataClientSelected.id : 0,
                  "dgi_qr": "0",
                  "Orden": preOrderGroups,
                  "combos": preOrderCombos,
                  "Descuento": discount,
                  "Total": total,
                  "itbms": tax,
                  "subtotal": subtotal,
                  "machine_id": machine.id,
                  "branchoffice_id": branchoffice.id,
                  "tipoOrden": checkDeliveryOrder,
                  "paymethod": 0,
                  "localizador": 0,
                  "discounts": dataDicountApply,
                  "is_discount_notification": false,
                  "is_cupon": false,
                  "is_authorized": true,
                  "is_devolution_notification": false,
                  "taxes": taxesArrayAll,
                  "is_pre_order": true,
                  "user": {
                     id: user.id,
                     name: user.name,
                     code: user.user_code
                  },
                  "email_cc": [email_cc],
                  "aditional_info": aditional_data,
                  "client_address": addresDescriptionClientFiscal
               }

               if (eventDataState !== null) {
                  json.event_id = eventDataState.id
                  json.event_name = eventDataState.name;
               }

               if (events.length > 0 && selectedEvent != null) {
                  json.event_id = selectedEvent.id
               }

               if (formType == "quote") {
                  json.is_pre_order = false
                  json.is_quote_order = true
                  json.client_email = email
                  json.client_phone = phone
                  json.note = note
               }

               if (selectedTable != null) {
                  json.table_name = selectedTable.raw?.number || null
                  json.table_id = selectedTable?.value || null
                  json.table_code = selectedTable.raw?.code || null
               }

               if (micros != undefined) { json.micros_reference = micros.micros_reference }

               //We check if the user logged is a waiter to send the waiter info to the pre-order
               if (localStorage.getItem("user") && JSON.parse(localStorage.getItem("user")).role.find(r => r.name === "Mesero") != undefined) {
                  json.waiter = {
                     id: JSON.parse(localStorage.getItem("user")).id,
                     name: JSON.parse(localStorage.getItem("user")).name,
                     code: JSON.parse(localStorage.getItem("user")).user_code
                  }
               }


               try {
                  const response = await PreOrderFetchAPI.createPreOrder(json, token)
                  if (formType == "quote") {
                     const dataNewQuote = await getTemporalOrderByCode(response.data.newTempOrder.code);
                     let newdataOrder = dataNewQuote.data.order
                     handleSaveFiles(newdataOrder)
                     //let logo = localStorage.getItem("businessLogo")

                     let newShoppingCart = []
                     newdataOrder.groups.forEach(item => {
                        newShoppingCart.push({
                           ...item,
                           price: item.price.toFixed(2),
                           total: (item.price * item.amount).toFixed(2)
                        });
                     });

                     let dataEmailJson = {
                        "cc": newdataOrder.email_cc ? newdataOrder.email_cc : "",
                        "template": "quote_detaills",
                        "subject": "Cotizacion " + newdataOrder?.transaction_code + " Actualizada por el administrador",
                        "email": newdataOrder.client_email,
                        "emit": {
                           "name": branchoffice.fiscal_name,
                           "ruc": branchoffice.ruc,
                           "dv": branchoffice.dv
                        },
                        "branchoffice": {
                           "name": newdataOrder.branchoffice.name,
                        },
                        "business": {
                           "name": newdataOrder.business.name,
                        },
                        "client_name": newdataOrder.client_name,
                        "client_ruc": newdataOrder.client_ruc,
                        "client_dv": newdataOrder.client_dv,
                        "client_phone": newdataOrder.client_phone,
                        "code": newdataOrder.code,
                        "business_color": newdataOrder.business.color,
                        "discount_total": newdataOrder.discount.toFixed(2),
                        "footer_note": "Esta cotizacion es valida por 15 dias.",
                        "invoice_total": newdataOrder.total.toFixed(2),
                        "items": newShoppingCart,
                        "logo_url": logo,
                        "sub_total": newdataOrder.subtotal.toFixed(2),
                        "tax_total": newdataOrder.tax.toFixed(2),
                        "tips_total": newdataOrder.tips.toFixed(2),
                        "created_at": newdataOrder.createdAt,
                        "business_color": dataStyleBusiness?.layaoutColor ? dataStyleBusiness.layaoutColor : "#000000",
                        "buttonRedirect": "https://" + domainBusiness + ".ecommerce.smartpay.ai/order/quote/" + newdataOrder.code,
                        "note": newdataOrder.note ? newdataOrder.note : "",
                        "transaction_code": newdataOrder?.transaction_code,
                        "client_address": newdataOrder.client_address ? newdataOrder.client_address : "",
                        "aditional_info": newdataOrder.aditional_info ? newdataOrder.aditional_info : "",
                     }
                     sendMail(dataEmailJson);


                     setSelectedQuote(response.data.newTempOrder)
                     setShowQuoteDetails(true)
                  }
                  if (formType == "preOrder") {
                     setShowSimplePrintModal(true)
                     setDataCreatePreOrder({ id: response.data.newTempOrder._id, code: response.data.newTempOrder.code })
                     //printOrder(response.data.newTempOrder._id, response.data.newTempOrder.code)
                  } else {
                     localStorage.removeItem('client_data');
                     localStorage.removeItem('addressNowLocation');
                     setdataClientSelected(null);
                     setAddressNowLocation(null);
                     setTableNumber(0);
                     setPageLoader(1)
                  }
                  setFormType("preOrder")
                  setEmail_cc("")
                  setStateRequest(false)

                  setShow(false)
                  let message = "Precuenta creada con exito."
                  let title = "Operacion exitosa."
                  let icon = "success"
                  AlertSmall(message, icon)
               } catch (err) {
                  setStateRequest(false)
                  showApiError(err, {
                     title: formType == "quote" ? "No se pudo crear la cotizacion" : "No se pudo crear la precuenta",
                     message: "El servidor no pudo crear la precuenta.",
                     context: `branch=${branchoffice?.code || ""}`,
                  }, ErrorAlert);

               }
            } else {
               setStateRequest(false)
               ErrorAlert("Debes agregar  algo al carrito", "No hay productos en el carrito", "info")
            }
         }
      } else {

      }
   }



   //format data to send to micros
   const formatDataMicrosCheck = (groups, combos, action) => {
      //Json general format
      let jsonMicrosCheck = {
         RvcRef: paramsMicros.pos_integration_params.RvcRef,
         employeeNum: paramsMicros.pos_integration_params.employeeNum,
         host_url: paramsMicros.pos_integration_params.host_url,
         localMicrosServerIp: paramsMicros.pos_integration_params.localMicrosServerIp,
         products: [],
         automatic_payment: 0,
         delivery: false,
         client: { name: name, phone: "00" },
         paymentmethods: [{
            "name": "Credito",
            "paymenthod_id": 10,
            "total": total
         }],
      }

      if (action == "update") {
         let preOrderOld = JSON.parse(localStorage.getItem('preOrderComparativeOld'))
         jsonMicrosCheck.checkSeq = preOrderOld.micros_reference.checkSeq
         jsonMicrosCheck.checkNum = preOrderOld.micros_reference.checkNum
      }

      let data = []
      //json product format
      groups.forEach(product => {
         let dataDetail = {
            "code": product.group_id,
            "name": product.name,
            "price": product.price,
            "cant": product.amount,
            "tax": product.taxes[0].tax,
            "total_discount": product.discount,
            "exist_product": false,
            "total_product": product.price,
            "external_reference": product.external_reference,
            "type": "product",

         }

         let dataSegments = []


         product.segments.forEach(segment => {
            let detail = {
               "external_reference": segment.external_reference,
               "name": segment.name,
               "amount": segment.amount,
            }
            dataSegments.push(detail)
         })
         dataDetail.condiments = dataSegments
         data.push(dataDetail)
      });

      //----------------------------------------------
      //format combos
      combos.forEach(combo => {


         let dataDetailCombo = {
            "type": "combo",
            "code": combo.combo_id,
            "tax": combo.taxes[0].tax,
            "total_discount": combo.discount,
            "exist_product": false,
            "total_product": combo.price,
            "external_reference": combo.referenced_group.external_reference,
            "price": combo.price,
            "name": combo.name,
            "cant": combo.amount,
            "mainDetail": {},
            "sideDetails": [],
         }
         let setGroupsData = []
         combo.setGroups.forEach(setGroup => {

            setGroup.groups.forEach(group => {
               //json group format
               let dataDetail = {
                  "name": group.name,
                  "external_reference": group.external_reference,
                  "isMainProduct": false,
               }

               let dataSegments = []
               group.segments.forEach(segment => {
                  let detail = {
                     "external_reference": segment.external_reference,
                     "name": segment.name,
                     "amount": segment.amount,
                  }
                  dataSegments.push(detail)
               })
               //add data segments to group
               dataDetail.condiments = dataSegments

               if (setGroup.isMainSetGroup == 1) {
                  //add data to main detail
                  dataDetail.isMainProduct = true
                  dataDetailCombo.mainDetail = dataDetail
               } else {
                  //add data to side details
                  dataDetail.price = group.price
                  dataDetail.cant = group.amount
                  dataDetail.total = group.price
                  setGroupsData.push(dataDetail)
               }
            })
            //add data side details to combo
            dataDetailCombo.sideDetails = setGroupsData
         })
         //add combo to products
         data.push(dataDetailCombo)
      })
      jsonMicrosCheck.products = data
      createCheckMicrosOrderLocal(jsonMicrosCheck, action)
   }

   //request local to create open check in micros
   const createCheckMicrosOrderLocal = async (jsonMicrosCheck, action) => {
      let token = localStorage.getItem('x-access-machine-token');
      let type = "POST"
      if (action == "update") {
         type = "PUT"
      }
      let data = {
         Ruta: `http://${jsonMicrosCheck.localMicrosServerIp}:9472/api/micros/checks?RvcRef=${jsonMicrosCheck.RvcRef}&employeeNum=${jsonMicrosCheck.employeeNum}&host_url=${jsonMicrosCheck.host_url}`,
         Type: type,
         Header: { "x-access-token": token },
         Body: jsonMicrosCheck
      }




      let micros_response;
      try {
         micros_response = await RequestLocalFetchAPI.postMicros(data);


         //We validate if the micros response is success
         if (action == "create") {
            if (micros_response.data.micros_response.PostTransactionExResponse.pTotalsResponse.OperationalResult.ErrorCode._text !== undefined && micros_response.data.micros_response.PostTransactionExResponse.pTotalsResponse.OperationalResult.ErrorCode._text === "Success") {

               //We add the data that we want to update 
               let data_to_update = {
                  micros_reference: {
                     checkNum: micros_response.data.micros_response.PostTransactionExResponse.pGuestCheck.CheckNum._text,
                     checkSeq: micros_response.data.micros_response.PostTransactionExResponse.pGuestCheck.CheckSeq._text,
                  }
               }
               //We make the update of the order 
               createPreOrder(data_to_update)
            }
         } else if (action == "update") {
            updatePreOrder()
         }
      } catch (err) {

      }
   }

   //function action print order
   let arrayPrintersTemp = []

   const getPrinter = async () => {
      try {
         const response = await PrinterFetchAPI.getPrinter(localStorage.getItem('x-access-machine-token'), machine.id);

         let arrayPrinters = response.data.printers;
         let printer_Comanda = "";
         let printer_ticket = "";
         let printer_zebra = "";
         let printer_ip = "";
         for (let i = 0; i < arrayPrinters.length; i++) {
            getCategoriesByprinter(arrayPrinters[i])
            if (arrayPrinters[i].printer_type == 'Tickets') {
               printer_ticket = arrayPrinters[i].printer_name
               printer_ip = arrayPrinters[i].ip || ""
            } else if (arrayPrinters[i].printer_type == 'Comanda') {
               printer_Comanda = arrayPrinters[i].printer_name
            } else if (arrayPrinters[i].printer_type == 'Zebra') {
               printer_zebra = arrayPrinters[i].printer_name;
            }
         }

         setPrinters(arrayPrintersTemp)
         setInfoPrinter({ printer_comanda: printer_Comanda, printer_ticket: printer_ticket, printer_zebra: printer_zebra, printer_ip: printer_ip });

      } catch (err) {

      }
   }



   const getCategoriesByprinter = async (printer) => {

      try {
         const response = await CategriesPosFetchAPI.getCategoriesByPrinters(printer.printer_id, localStorage.getItem('x-access-machine-token'))
         printer.categories = response.data.categories

      } catch (err) {
         printer.categories = []

      }
      arrayPrintersTemp.push(printer)

   }

   //print order
   const printOrder = async (id_Orden_Imprimir, transaction_code, onlyComanda) => {
      let ip_print = "localhost"
      const isUpdatingExistingPreOrder = Boolean(dataPreOrder?._id || selectPreOrder?._id);
      const hasKitchenItemsToPrint = hasPreOrderKitchenItemsToPrint(preOrderGroups, preOrderCombos, {
         printUnmarkedItems: !isUpdatingExistingPreOrder,
      });

      if (localStorage.getItem("ip_printer") != "" && localStorage.getItem("ip_printer") != undefined && localStorage.getItem("ip_printer") != null) {
         ip_print = localStorage.getItem("ip_printer")
      }

      let dataPrinters = printers
      if (onlyComanda == true) {
         if (!hasKitchenItemsToPrint) {
            AlertSmall("No hay productos pendientes para enviar a cocina", "info")
            return;
         }
         dataPrinters = printers.filter(printer => printer.printer_type === "Comanda")
      } else if (!hasKitchenItemsToPrint) {
         dataPrinters = printers.filter(printer => printer.printer_type === "Tickets")
      }

      let JsonImprimir = [{
         "type_ticket": "precuenta",
         "table_name": tableNumber,
         "Printers": dataPrinters,
         "Nombre_maquina_impresora": infoPrinter.printer_ticket,
         "Nombre_cocina_impresora": infoPrinter.printer_comanda,
         "Nombre_zebra_impresora": infoPrinter.printer_zebra,
         "PRINTER_IP": infoPrinter.printer_ip,
         "Id_Orden_Imprimir": id_Orden_Imprimir,
         "token": localStorage.getItem('x-access-machine-token'),
         "transaction_code": transaction_code,
         "amount_item": shoppingCart.length,
         "imprimir_comanda": hasKitchenItemsToPrint ? "si" : "no",
      }]


      printOrderData(JsonImprimir);
      localStorage.removeItem('client_data');
      localStorage.removeItem('addressNowLocation');
      setdataClientSelected(null);
      setAddressNowLocation(null);
      setTableNumber(0);
      setPageLoader(1)

      try {
         const response_machine = await MachinesFetchAPI.getmachineByid(machine.id, localStorage.getItem('x-access-machine-token'));

         if (ip_print == "localhost") {
            const response = await PrinterFetchAPI.printOrder(ip_print, JsonImprimir, response_machine.data.data.windows_ip)
         } else {
            const response = await PrinterFetchAPI.printByServerMiddle(ip_print, JsonImprimir)
         }


         AlertSmall("Orden enviada a imprimir", "success")

      } catch (err) {

      }
   }

   // view get order to return
   const cardGetOrder = () => {

      // ← estado vacío
      if (!preOrderGroups || preOrderGroups.length === 0) {
         return (
            <div className="sp-poi-empty">
               <i className="uil uil-shopping-basket"></i>
               <p>No hay productos aquí</p>
            </div>
         );
      }
      const cardOrder = preOrderGroups.map((product, index) => (
         <div key={index}>

            {product.type == "separator" ? <>
               <div className="sp-poi-sep">
                  <span className="sp-poi-sep__label">{product.name}</span>
               </div>
            </> : <>
               <div className="sp-poi">
                  <div className="sp-poi__top">
                     <img
                        className="sp-poi__thumb"
                        loading="lazy"
                        src={buildCloudinaryImageUrl({ url: product.img, type: "image", width: 300, quality: "auto" }) || defaultImage}
                        width="42" height="42"
                        alt={product.name}
                     />
                     <div className="sp-poi__info">
                        <div className="sp-poi__name">{product.name}</div>
                     </div>
                     <div className="sp-poi__price" translate="no">$ {product.price.toFixed(2)}</div>
                  </div>

                  <details className="sp-poi__details" open>
                     <summary className="sp-poi__summary">
                        <i className="uil uil-info-circle"></i> Detalles
                     </summary>
                     <ul className="sp-poi__seglist">
                        {product.segments.map((item, idx) => (
                           <li key={idx} className="sp-poi__seg">
                              <span className="sp-poi__seg-name">{item.segment_name}: {item.name}</span>
                              <span className="sp-poi__seg-price" translate="no">${Number(item.price).toFixed(2)}</span>
                           </li>
                        ))}
                     </ul>
                  </details>
                  <div className=" d-flex justify-content-end">
                     {/* Switch kitchen_action */}
                     {selectPreOrder?.is_quote_order == true || formType == "quote" || formType == "" ? <></> : <>
                        {dataPreOrder.pre_Order && dataPreOrder.pre_Order == true && product.kitchen_action === 'send_to_kitchen' ? <>
                           {product?.isNewAdd == true ? <>
                              <div className="sp-poi__kitchen">
                                 <Form.Check
                                    type="switch"
                                    id={`kitchen-switch-group-${index}`}
                                    label={product.kitchen_action === 'send_to_kitchen' ? 'Enviar a cocina' : 'Mantener en espera'}
                                    checked={product.kitchen_action === 'send_to_kitchen'}
                                    onChange={(e) => handleToggleKitchenActionGroup(index, e.target.checked)}
                                 />
                              </div>
                           </> : <>
                              <Badge rounded className="w-100 mt-2" bg="warning" text="black">Enviado a cocina</Badge>
                           </>}
                        </> : <>
                           <div className="sp-poi__kitchen">
                              <Form.Check
                                 type="switch"
                                 id={`kitchen-switch-group-${index}`}
                                 label={product.kitchen_action === 'send_to_kitchen' ? 'Enviar a cocina' : 'Mantener en espera'}
                                 checked={product.kitchen_action === 'send_to_kitchen'}
                                 onChange={(e) => handleToggleKitchenActionGroup(index, e.target.checked)}
                              />
                           </div>
                        </>}</>}
                  </div>

               </div>
            </>}
         </div>
      ));
      return (cardOrder)
   }

   // view get order to return
   const cardGetOrderCombo = () => {
      const cardOrder = preOrderCombos.map((product, index) => (
         <>

            <div >
               <div className="d-flex rounded m-1 bg-white mt-1 card-pos">
                  <div className="flex-shrink-0">
                     <img className='m-1 rounded  bg-light border ' loading='lazy' src={buildCloudinaryImageUrl({ url: product.img, width: 300, quality: "auto", type: "image" }) || defaultImage} width="42" height="42" />
                  </div>
                  <div className="flex-grow-1 m-1">
                     <div className="d-flex bd-highlight">
                        <div className="bd-highlight title-product-cart mt-1 text-dark fw-bold">
                           {product.name}
                        </div>
                        <div className="ms-auto px-2 bd-highlight text-price-cart" translate='no'>
                           $ {product.price.toFixed(2)}
                        </div>
                     </div>

                     <div className={``}>
                        {product.setGroups.map((setGroup) => (
                           <div className="d-flex justify-content-between" key={setGroup.set_id}>
                              <details close >
                                 <summary className=''>
                                    <span className='badge bg-light text-dark summary-text-pos  fw-bold border rounded-4  text-wrap m-1 '>
                                       <i className="uil uil-info-circle  px-1 "> {setGroup.name}</i>
                                    </span>
                                 </summary>
                                 {setGroup.groups.map((group) => (<>
                                    {cardGroup(group)}
                                 </>))}
                              </details>
                           </div>))}
                     </div>

                     {/* Switch kitchen_action for combo */}
                     <div className="align-self-center me-2">
                        <Form.Check
                           type="switch"
                           id={`kitchen-switch-combo-${index}`}
                           label={
                              product.kitchen_action === 'send_to_kitchen'
                                 ? 'Enviar a cocina'
                                 : 'Mantener en espera'
                           }
                           checked={product.kitchen_action === 'send_to_kitchen'}
                           onChange={(e) =>
                              handleToggleKitchenActionCombo(index, e.target.checked)
                           }
                        />
                     </div>

                  </div>


               </div>
            </div>
         </>
      ));
      return (cardOrder)
   }


   // update pre order
   const updatePreOrder = async (micros) => {
      if (stateRequest == false) {
         setStateRequest(true)
         let token = localStorage.getItem('x-access-machine-token');
         let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))

         let dataEmial_cc = selectPreOrder.email_cc ? selectPreOrder.email_cc : []
         if (email_cc && email_cc != "") {
            dataEmial_cc.push(email_cc)
         }
         let json = {
            "client_name": name,
            "localizador": "00",
            "table_name": tableNumber,
            "ruc": ruc,
            "dv": dv,
            "is_discount_notification": false,
            "_id": dataPreOrder._id,
            "order_type": checkDeliveryOrder,
            "groups": preOrderGroups,
            "combos": preOrderCombos,
            "discounts": dataDicountApply,
            "taxes": taxesArrayAll,
            "discount": discount,
            "is_authorized": true,
            "total": total,
            "tax": tax,
            "subtotal": subtotal,
            "note": note,
            "removed_products": removedPreOrderShoppingCartProducts,
            "email_cc": dataEmial_cc,
            "aditional_info": aditional_data,
            "client_address": addresDescriptionClientFiscal
         }

         if (micros != undefined) { json.micros_reference = micros.micros_reference }

         try {
            const response = await PreOrderFetchAPI.updateOrderTempPreOrder(json, token)
            setStateRequest(false)


            if (selectPreOrder?.is_quote_order == true) {
               const dataNewQuote = await getTemporalOrderByCode(selectPreOrder.code);
               let newdataOrder = dataNewQuote.data.order
               let logo = localStorage.getItem("businessLogo")



               let newShoppingCart = []

               newdataOrder.groups.forEach(item => {
                  newShoppingCart.push({
                     ...item,
                     price: item.price.toFixed(2),
                     total: (item.price * item.amount).toFixed(2)
                  });
               });

               let dataEmailJson = {
                  "cc": dataEmial_cc,
                  "template": "quote_detaills",
                  "subject": "Cotizacion " + newdataOrder?.transaction_code + " Actualizada por el administrador",
                  "email": newdataOrder.client_email,
                  "emit": {
                     "name": branchoffice.fiscal_name,
                     "ruc": branchoffice.ruc,
                     "dv": branchoffice.dv

                  },
                  "branchoffice": {
                     "name": newdataOrder.branchoffice.name,
                  },
                  "business": {
                     "name": newdataOrder.business.name,
                  },
                  "client_name": newdataOrder.client_name,
                  "client_ruc": newdataOrder.client_ruc,
                  "client_dv": newdataOrder.client_dv,
                  "client_phone": newdataOrder.client_phone,
                  "code": newdataOrder.code,
                  "business_color": newdataOrder.business.color,
                  "discount_total": newdataOrder.discount.toFixed(2),
                  "footer_note": "Esta cotizacion es valida por 15 dias.",
                  "invoice_total": newdataOrder.total.toFixed(2),
                  "items": newShoppingCart,
                  "logo_url": logo,
                  "sub_total": newdataOrder.subtotal.toFixed(2),
                  "tax_total": newdataOrder.tax.toFixed(2),
                  "tips_total": newdataOrder.tips.toFixed(2),
                  "created_at": newdataOrder.createdAt,
                  "business_color": dataStyleBusiness?.layaoutColor ? dataStyleBusiness.layaoutColor : "#000000",
                  "buttonRedirect": "https://" + domain + "/order/quote/" + newdataOrder.code,
                  "note": newdataOrder.note ? newdataOrder.note : "",
                  "transaction_code": newdataOrder?.transaction_code,
                  "client_address": newdataOrder.client_address ? newdataOrder.client_address : "",
                  "aditional_info": newdataOrder.aditional_info ? newdataOrder.aditional_info : "",
               }
               sendMail(dataEmailJson);
            }

            if (micros != undefined) {

            } else {
               if (formType == "preOrder") {
                  //printOrder(response.data._id, response.data.code)
                  setShowSimplePrintModal(true)
                  setDataCreatePreOrder({ id: response.data._id, code: response.data.code })

               }

               setShow(false)
               /* let message = "Precuenta actualizada con exito."
                let title = "Operacion exitosa"
                let icon = "success"
                setPageLoader(1)
                ErrorAlert(message, title, icon)*/
            }

            setFormType("preOrder")
            setEmail_cc("")

         } catch (err) {
            setStateRequest(false)
            showApiError(err, {
               title: selectPreOrder?.is_quote_order == true ? "No se pudo actualizar la cotizacion" : "No se pudo actualizar la precuenta",
               message: "El servidor no pudo actualizar la precuenta.",
               context: `pre_order_id=${dataPreOrder?._id || ""}`,
            }, ErrorAlert);

         }

      } else {

      }
   }

   const handlerChangeDataOrder = () => {


      if (dataPreOrder.pre_Order == true) {
         getPreOrderByid()
      }
      ErrorAlert("", "Nombre guardado", "success")
   }




   const viewFormPreOrderAndQuote = () => {
      return (<>
         <div className="sp-pf">

            {/* Encabezado del form */}
            <div className="sp-pf__head">
               {selectPreOrder?.is_quote_order == true ? <></> : <>
                  <button
                     className="sp-pf__switch"
                     onClick={() => { setFormType(formType == "preOrder" ? "quote" : "preOrder") }}
                  >
                     {formType == "preOrder"
                        ? <><i className="uil uil-clipboard-alt"></i> Cambiar a Cotización</>
                        : <><i className="uil uil-invoice"></i> Cambiar a Precuenta</>}
                  </button></>}
               <h5 className="sp-pf__title">Datos de Cliente</h5>
            </div>

            <div className="sp-pf__body">
               <ClientPillCard dataClientSelected={dataClientSelected} setdataClientSelected={setdataClientSelected} addressNowLocation={addressNowLocation} setAddressNowLocation={setAddressNowLocation} parthner_order={parthner_order} setShoppingCart={setShoppingCart} calculateInvoiceTotals={calculateInvoiceTotals} enabledOnlineOrder={enabledOnlineOrder} parthners={parthners} selectRestaurant={selectRestaurant} setResetData={setResetData} shoppingCart={shoppingCart} shoppingCartCombos={shoppingCartCombos} setShoppingCartCombos={setShoppingCartCombos} />

               {eventsAndDates()}

               {formType == "preOrder" ? <>
                  {/* Nombre de la cuenta + Fecha */}
                  <div className="sp-pf__grid2">
                     <div className="sp-pf__field">
                        <span className="sp-pf__label">Nombre de la cuenta</span>
                        <input
                           type="text"
                           className="sp-pf__input sp-pf__input--center"
                           value={name || ''}
                           onChange={e => setName(e.target.value)}
                           placeholder="Nombre de la cuenta"
                           style={{ fontWeight: 'bold' }}
                        />
                     </div>
                     <div className="sp-pf__field">
                        <span className="sp-pf__label">Fecha</span>
                        <span className="sp-pf__static">{date}</span>
                     </div>
                  </div>

                  {selectPreOrder?.is_quote_order === true ? <></> : <>
                     <div className="sp-pf__field">
                        <span className="sp-pf__label">Mesa</span>
                        <Select
                           value={selectedTable}
                           onChange={(opt) => { setSelectedTable(opt); setTableNumber(opt?.raw?.number) }}
                           options={tableOptions}
                           isClearable
                           placeholder="Buscar mesa/stand..."
                           noOptionsMessage={() => "No hay mesas que coincidan"}
                           classNamePrefix="sp-rs"
                        />
                     </div>
                  </>}

                  <details className="sp-pf__acc">
                     <summary className="sp-pf__accsum"><i className="uil uil-edit"></i> Editar</summary>
                     <div className="sp-pf__accbody">
                        {/*<Modalclient getClientsByBusiness={getClientsByBusiness} setRuc={setRuc} setName={setName} setDv={setDv} setDataResponse={setDataResponse}></Modalclient>*/}
                        <Form>
                           <Form.Group className="mb-1" controlId="formBasicText">
                              <Form.Label>Ingresa un nombre</Form.Label>
                              <Form.Control placeholder={name} onChange={(e) => (setName(e.target.value))} />
                           </Form.Group>
                        </Form>
                     </div>
                  </details>
               </> : <>
                  {/* ===== COTIZACIÓN: campos obligatorios ===== */}
                  <div className="sp-pf__field">
                     <span className="sp-pf__label"><i className="uil uil-user-circle"></i> Nombre completo</span>
                     <input
                        type="text"
                        value={name || ''}
                        className={`sp-pf__input${!name || name.trim() === '' ? ' is-invalid' : ''}`}
                        placeholder="Ingresa tu nombre completo"
                        onChange={(e) => setName(e.target.value)}
                        required
                     />
                     {(!name || name.trim() === '') && (<small className="sp-pf__err">Este campo es obligatorio</small>)}
                  </div>

                  <div className="sp-pf__field">
                     <span className="sp-pf__label"><i className="uil uil-user"></i> Correo electrónico:</span>
                     <input
                        type="email"
                        className={`sp-pf__input${!email || email.trim() === '' ? ' is-invalid' : ''}`}
                        placeholder="Example@txt.com"
                        value={email || ''}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                     />
                     {(!email || email.trim() === '') && (<small className="sp-pf__err">Este campo es obligatorio</small>)}
                  </div>

                  <div className="sp-pf__field">
                     <span className="sp-pf__label"><i className="uil uil-phone-alt"></i> Teléfono</span>
                     <Form.Group className="mb-0 w-100" controlId="phone2">
                        <PhoneInput
                           country={'pa'}
                           value={phone || ''}
                           onChange={phone => (setPhone(phone))}
                           inputProps={{ name: 'phone2', required: true, autoFocus: true }}
                           countryCodeEditable={false}
                           enableSearch
                           inputStyle={!phone || phone.trim() === '' ? { borderColor: '#dc3545' } : {}}
                        />
                        {(!phone || phone.trim() === '') && (<small className="sp-pf__err">Este campo es obligatorio</small>)}
                     </Form.Group>
                  </div>

                  <div className="sp-pf__field">
                     <span className="sp-pf__label"><i className="uil uil-user"></i> Correo electrónico cc (Opcional):</span>
                     <input
                        type="email_cc"
                        className="sp-pf__input"
                        placeholder="Example@txt.com"
                        value={email_cc || ''}
                        onChange={(e) => setEmail_cc(e.target.value)}
                        required
                     />
                  </div>

                  {/* Información adicional */}
                  <details className="sp-pf__acc">
                     <summary className="sp-pf__accsum">
                        <span className="sp-pf__arrow">&#9654;</span> Informacion adicional
                     </summary>
                     <div className="sp-pf__accbody">
                        <Form.Group className="mb-3" controlId="formBasicText">
                           <Form.Label>Direccion fiscal</Form.Label>
                           <Form.Control placeholder="Ejemplo Calle # etc... " value={addresDescriptionClientFiscal} maxLength={90} onChange={(e) => (setAddresDescriptionClientFiscal(e.target.value))} />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formBasicText">
                           <Form.Label>Dato adicional</Form.Label>
                           <Form.Control as="textarea" className="text-area-modal" placeholder="Orden de compra - direccion " value={aditional_data} onChange={(e) => (setAditional_data(e.target.value))} />
                        </Form.Group>

                        {/* Adjuntar archivos */}
                        {selectPreOrder.files && selectPreOrder.files.length > 0 ? <></> : <>
                           <div className="sp-pf__field">
                              <span className="sp-pf__label"><i className="uil uil-paperclip"></i> Adjuntar archivos (opcional)</span>
                              <input
                                 type="file"
                                 className="sp-pf__input sp-pf__file"
                                 onChange={handleFileChange}
                                 accept="image/*,application/pdf,.doc,.docx,.xls,.xlsx,.txt"
                                 multiple
                                 max={10}
                              />
                              {attachedFiles.length > 0 && (
                                 <div className="sp-pf__files">
                                    <span className="sp-pf__files-t">Archivos seleccionados:</span>
                                    <ul className="sp-pf__files-list">
                                       {attachedFiles.map((file, idx) => (<li key={idx}>{file.name}</li>))}
                                    </ul>
                                 </div>
                              )}
                           </div></>}
                     </div>
                  </details>

                  {/* RUC / DV */}
                  <details className="sp-pf__acc">
                     <summary className="sp-pf__accsum"><i className="uil uil-edit"></i> RUC / DV</summary>
                     <div className="sp-pf__accbody">
                        <span className="sp-pf__ok">{name}</span>
                        <div className="sp-pf__grid2">
                           <div className="sp-pf__field">
                              <span className="sp-pf__label">Número de RUC</span>
                              <input
                                 type="text"
                                 className="sp-pf__input"
                                 placeholder="0-0000-0"
                                 value={ruc}
                                 onChange={(e) => setRuc(e.target.value)}
                              />
                           </div>
                           <div className="sp-pf__field">
                              <span className="sp-pf__label">Número DV</span>
                              <input
                                 type="number"
                                 className="sp-pf__input"
                                 placeholder="00"
                                 value={dv}
                                 onChange={(e) => setDv(e.target.value)}
                              />
                           </div>
                        </div>
                        <button className="sp-pf__validate" type="button" onClick={authenticationDgi} title="Validar RUC">
                           Validar RUC
                        </button>
                     </div>
                  </details>
               </>}

               {/* Notas (cotización) / Totales (precuenta) */}
               {selectPreOrder?.is_quote_order == true || formType == "quote" ? <>
                  <div className="sp-pf__notes">
                     <h5 className="sp-pf__notes-title">Notas</h5>
                     <Form>
                        <Form.Group className="m-0" controlId="exampleForm.ControlTextarea1">
                           <Form.Control as="textarea" className="text-area-modal" value={note} onChange={(e) => (setNote(e.target.value))} placeholder="Escribir..." />
                        </Form.Group>
                     </Form>
                  </div>
               </> : <>
                  <div className="sp-pf__totals-wrap">
                     <span className="sp-pf__totals-title">Totales</span>
                     <div className="sp-pf__totals">
                        <div className="sp-pf__tcard">
                           <strong>Descuento</strong>
                           <span translate="no">$ {discount.toFixed(2)}</span>
                        </div>
                        <div className="sp-pf__tcard">
                           <strong>Impuestos</strong>
                           <span translate="no">$ {tax.toFixed(2)}</span>
                        </div>
                        <div className="sp-pf__tcard">
                           <strong>Subtotal</strong>
                           <span translate="no">$ {subtotal.toFixed(2)}</span>
                        </div>
                        <div className="sp-pf__tcard sp-pf__tcard--total">
                           <strong>Total <small>(+Impuestos)</small></strong>
                           <span translate="no">$ {total.toFixed(2)}</span>
                        </div>
                     </div>
                  </div>
               </>}
            </div>
         </div>
      </>)
   }


   //function to compare data micros and update
   const handlerComparativeNewData = () => {
      let preOrderComparativeOld = JSON.parse(localStorage.getItem('preOrderComparativeOld'))
      let OrderGroupsOld = preOrderComparativeOld.groups
      let OrderCombosOld = preOrderComparativeOld.combos
      let newGroups = []
      let newCombos = []

      //comparative groups
      shoppingCart.forEach(group => {
         let groupOld = OrderGroupsOld.find(item => item.group_id == group.group_id && item.segments_string == group.segments_string)

         if (groupOld != undefined) {
            if (groupOld.amount != group.amount) {
               let newGroup = groupOld
               newGroup.amount = (group.amount - groupOld.amount)
               newGroup.cantidadItem = (group.amount - groupOld.amount)
               newGroups.push(newGroup)
            }
         } else {
            newGroups.push(group)
         }
      });

      //Add string data to compare
      shoppingCartCombos.forEach(combo => {
         let stringdata = combo.combo_id + "";
         combo.setGroups.forEach(setGroup => {
            stringdata += setGroup.set_id;
            setGroup.groups.forEach(group => {
               stringdata += group.group_id;
               group.segments.forEach(segment => {
                  stringdata += segment.segment_id + segment.item.item_id;
               });
            });
         });
         combo.combo_string = stringdata;
      });

      //Add string data to compare
      OrderCombosOld.forEach(comboOld => {
         let stringdataOld = comboOld.combo_id + "";
         comboOld.setGroups.forEach(setGroup => {
            stringdataOld += setGroup.set_id;
            setGroup.groups.forEach(group => {
               stringdataOld += group.group_id;
               group.segments.forEach(segment => {
                  stringdataOld += segment.segment_id + segment.item.item_id;
               });
            });
         });
         comboOld.combo_string = stringdataOld;
      });

      //==========================================
      //Comparative combos
      shoppingCartCombos.forEach(combo => {
         let comboOld = OrderCombosOld.find(comboOld => comboOld.combo_id == combo.combo_id && comboOld.combo_string == combo.combo_string)

         if (comboOld != undefined) {
            if (comboOld.amount != combo.amount) {
               let newCombo = comboOld
               newCombo.amount = (combo.amount - comboOld.amount)
               newCombo.cantidadItem = (combo.amount - comboOld.amount)
               newCombos.push(newCombo)
            }
         } else {
            newCombos.push(combo)
         }
      });

      formatDataMicrosCheck(newGroups, newCombos, "update")
   }

   // Toggle kitchen_action for single product (group)
   const handleToggleKitchenActionGroup = (index, isChecked) => {
      setPreOrderGroups(prev =>
         prev.map((p, i) =>
            i !== index ? p : {
               ...p,
               kitchen_action: isChecked ? 'send_to_kitchen' : 'hold',
               isNewAdd: isChecked,
               amount_to_impress: isChecked ? Number(p.amount_to_impress || p.amount || 1) : 0,
            }
         )
      );
   };

   // Toggle kitchen_action for combos
   const handleToggleKitchenActionCombo = (index, isChecked) => {
      setPreOrderCombos(prev =>
         prev.map((c, i) =>
            i !== index ? c : {
               ...c,
               kitchen_action: isChecked ? 'send_to_kitchen' : 'hold',
               isNewAdd: isChecked,
               amount_to_impress: isChecked ? Number(c.amount_to_impress || c.amount || 1) : 0,
            }
         )
      );
   };


   // ====== CRUD branchoffice tables ======
   const getBranchofficeTables = async () => {
      try {
         let response = await TablesFetchAPI.getBranchofficeTables(branchoffice?.id, token);
         // We set the tables
         setTables(response.data.tables.map(table => ({
            id: table.id,
            number: table.name,
            code: table.code,
            zone: table.branchoffice_environment_id,
         })));
      } catch (e) {
         setTables([]);
      }
   };


   // options for the table select using  react-select
   const tableOptions = useMemo(() => {
      return (tables || []).map(t => ({
         value: t.id,
         label: `${t.name ?? `Mesa ${t.number ?? t.code ?? t.id}`}${t.environment_name ? ` • ${t.environment_name}` : ""}`,
         raw: t, // We keep the raw table data for later use when a table is selected
      }));
   }, [tables]);


   useEffect(() => {
      setEmail(dataClientSelected?.email)
      setPhone(dataClientSelected?.phone)
   }, [dataClientSelected])

   useEffect(() => {
      if (show) {
         // Clone groups with default kitchen_action
         const groupsWithKitchen = shoppingCart.map(p => ({
            ...p,
            kitchen_action: p.kitchen_action || 'send_to_kitchen'
         }));

         // Clone combos with default kitchen_action
         const combosWithKitchen = shoppingCartCombos.map(c => ({
            ...c,
            kitchen_action: c.kitchen_action || 'send_to_kitchen'
         }));

         setPreOrderGroups(groupsWithKitchen);
         setPreOrderCombos(combosWithKitchen);
      }
   }, [show, shoppingCart, shoppingCartCombos]);

   useEffect(() => {
      if (!show) return;

      //  API calls
      getBranchofficeTables();

      // Reset selection when opening
      setSelectedTable("");
   }, [show]);


   useEffect(() => {
      setNote(selectPreOrder?.note || "");
      setEmail(selectPreOrder?.client_email || "");
      setPhone(selectPreOrder?.client_phone || "");
      if (selectPreOrder?.is_quote_order == true) { setFormType("quote") } else {
         setFormType("preOrder")
      }
   }, [selectPreOrder])



   useEffect(() => {
      (async () => {


         try {
            let business = ''
            let token = ''
            let branchoffice = ''
            if (localStorage.getItem("branchoffice") !== "" || localStorage.getItem("branchoffice") !== null || localStorage.getItem("branchoffice") !== undefined) {

               business = JSON.parse(localStorage.getItem("business"))
               branchoffice = JSON.parse(localStorage.getItem("branchoffice"))

            }

            //We get the branchoffice info 
            const response_branch = await BranchOfficeFetchAPI.getBranchOfficeByCode(business.code, branchoffice.code);
            //We set the business data 
            setBranchofficeData(response_branch.data.branchoffice);

         } catch (err) {
            setBranchofficeData({
               "ruc": "",
               "dv": "",
               "name": "",
               "ruc_type": "",
               "direction": "",
               "dgi_name": "",
            })
         }
      })();
   }, []);

   return (
      <>

         {/* <button className='btn-pre-order px-2 py-1 btn btn-outline-light-secondary   rounded-3 btn-sm'
           >
            <small className='fw-bold buttons-label ' >
              */}
         {/* <span className='fw-bold d-none d-lg-inline'>{dataPreOrder.pre_Order && dataPreOrder.pre_Order == true
                  ? <> Actualizar{selectPreOrder?.is_quote_order == true ? <> Cotizacion</> : <> precuenta</>}</>

                  : <> Crear Precuenta</>}</span> */}
         {/* </small>
         </button> */}



         <button
            onClick={() => (setShow(true), getPrinter(), getPreOrderByid())}
            title="Separador de productos"
            style={{
               display: 'inline-flex',
               alignItems: 'center',
               gap: 7,
               width: 'auto',
               height: 'auto',
               flexShrink: 0,
               whiteSpace: 'nowrap',
               lineHeight: 1,
               padding: '8px 14px',
               border: '1px solid #EBEEF3',
               borderRadius: 10,
               background: '#fff',
               color: '#5B6B82',
               fontSize: 12.5,
               fontWeight: 600,
               cursor: 'pointer',
            }}
         >
            <i className="uil uil-align-center-v"></i>
            <span>{dataPreOrder.pre_Order && dataPreOrder.pre_Order == true
               ? <> Actualizar{selectPreOrder?.is_quote_order == true ? <> Cotizacion</> : <> precuenta</>}</>

               : <> Crear Precuenta</>}</span>
         </button>


         <Modal
            show={show}
            size="xl"
            centered
            onHide={() => (setShow(false), setFormType("preOrder"), setAttachedFiles([]), setEmail_cc(""))}
            dialogClassName="sp-pre-dialog"
            contentClassName="sp-pre-content"
         >
            <Modal.Body className="sp-pre">

               {/* Encabezado */}
               <div className="sp-pre__head">
                  <div className="sp-pre__badge"><i className="uil uil-receipt"></i></div>
                  <h2 className="sp-pre__title">
                     {dataPreOrder.pre_Order && dataPreOrder.pre_Order == true
                        ? <>Actualizar{selectPreOrder?.is_quote_order == true ? <> Cotizacion</> : <> precuenta</>}</>
                        : <>{formType == "preOrder" ? <>Crear Precuenta</> : <>{formType == "" ? <>Selecciona accion</> : <>Crear Cotización</>}</>}</>}
                  </h2>
                  <button
                     className="sp-pre__x"
                     type="button"
                     aria-label="Cerrar"
                     onClick={() => (setShow(false), setFormType("preOrder"), setAttachedFiles([]), setEmail_cc(""))}
                  >
                     <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
                  </button>
               </div>

               {/* 2 columnas */}
               <div className="sp-pre__grid">

                  {/* Izquierda: selección / formulario */}
                  <div className="sp-pre__col sp-pre__col--form">
                     {!formType && (
                        <div className="sp-pre__choose">
                           <button className="sp-pre__choice" onClick={() => setFormType('preOrder')}>
                              <i className="uil uil-file-alt"></i>
                              <span>Precuenta</span>
                           </button>
                           <button className="sp-pre__choice" onClick={() => setFormType('quote')}>
                              <i className="uil uil-file-copy-alt"></i>
                              <span>Cotización</span>
                           </button>
                        </div>
                     )}

                     {(formType === 'preOrder' || formType === 'quote') && (
                        <div className="sp-pre__formwrap">
                           {formType === 'preOrder' && (
                              <div className="w-100">
                                 {viewFormPreOrderAndQuote && viewFormPreOrderAndQuote('precuenta')}
                              </div>
                           )}
                           {formType === 'quote' && (
                              <div className="w-100">
                                 {viewFormPreOrderAndQuote && viewFormPreOrderAndQuote('cotizacion')}
                              </div>
                           )}
                        </div>
                     )}
                  </div>

                  {/* Derecha: productos + totales */}
                  <div className="sp-pre__col sp-pre__col--summary">
                     <div className="sp-pre__panel">
                        <h5 className="sp-pre__panel-title">Productos Incluidos en la Orden</h5>
                        <div className="sp-pre__items">
                           {cardGetOrder()}
                           {cardGetOrderCombo()}
                        </div>

                        {selectPreOrder?.is_quote_order == true || formType == "quote" ? <>
                           <div className="sp-pre__totals">
                              <div className="sp-pre__trow">
                                 <span>Descuento:</span>
                                 <span translate="no">$ {discount.toFixed(2)}</span>
                              </div>
                              <div className="sp-pre__trow">
                                 <span>Subtotal:</span>
                                 <span translate="no">$ {subtotal.toFixed(2)}</span>
                              </div>
                              <div className="sp-pre__trow">
                                 <span>Impuesto:</span>
                                 <span translate="no">$ {tax.toFixed(3)}</span>
                              </div>
                              <div className="sp-pre__trow sp-pre__trow--total">
                                 <span>Total <small>(Incluye itbms)</small>:</span>
                                 <span translate="no">$ {total.toFixed(2)}</span>
                              </div>
                           </div>
                        </> : <></>}
                     </div>
                  </div>
               </div>

               {/* Footer */}
               <div className="sp-pre__foot">
                  <button
                     className="sp-pre__btn sp-pre__btn--cancel"
                     onClick={() => (setShow(false), setFormType("preOrder"), setAttachedFiles([]), setEmail_cc(""))}
                  >
                     Cancelar
                  </button>

                  {dataPreOrder.pre_Order && dataPreOrder.pre_Order == true ? <>
                     <button className="sp-pre__btn sp-pre__btn--info" onClick={async () => (handlerUpdateValidation())}>
                        Actualizar{selectPreOrder?.is_quote_order == true ? <> Cotizacion</> : <> precuenta</>}
                     </button>
                  </> : <>
                     {formType == "" ? <></> : <>
                        <button className="sp-pre__btn sp-pre__btn--ok" onClick={() => (handlercreateValidation())}>
                           {formType == "preOrder" ? <>Crear Precuenta</> : <>Crear Cotización</>}
                        </button></>}
                  </>}
               </div>

            </Modal.Body>
         </Modal>


         {/* Modal simple de impresión */}
         <Modal show={showSimplePrintModal} centered size='sm-down'>
            <Modal.Body className="sp-preprint rounded-4">
               <div className="sp-preprint__ic"><i className="uil uil-print"></i></div>
               <h5 className="sp-preprint__title">Imprimir cuenta</h5>
               <p className="sp-preprint__msg">¿Quieres imprimir esta cuenta?</p>
               <div className="sp-preprint__acts">
                  <button className="sp-pre__btn sp-pre__btn--cancel"
                     onClick={() => (printOrder(datacreatePreOrder.id, datacreatePreOrder.code, true), setShowSimplePrintModal(false))}>
                     No
                  </button>
                  <button className="sp-pre__btn sp-pre__btn--ok"
                     onClick={() => (printOrder(datacreatePreOrder.id, datacreatePreOrder.code), setShowSimplePrintModal(false))}>
                     Sí
                  </button>
               </div>
            </Modal.Body>
         </Modal>

         {/* MODAL DETALLES DE COTIZACIÓN */}
         <ModalQuoteDetails
            show={showQuoteDetails}
            onClose={() => setShowQuoteDetails(false)}
            quote={selectedQuote}
            branchOfficeData={branchOfficeData}
            logo={logo}
            onShare={() => {
               if (selectedQuote) {
                  // Aquí puedes implementar la lógica de compartir (copiar link, abrir modal, etc)
                  navigator.clipboard.writeText(`https://${domainBusiness}.ecommerce.smartpay.ai/order/quote/${selectedQuote.code}`);
                  Swal.fire('¡Enlace copiado!', 'El enlace de la cotización ha sido copiado al portapapeles.', 'success');
               }
            }}
         />

      </>
   )
}

export default ModalCreatePreOrder
